// ============================================
//     Mapa de Actividades Avanzado (WordPress)
//     Uso de AdvancedMarkerElement y SuperClusterAlgorithm
//     Incluye geolocalización y sincronización de listado
// ============================================

/**
 * Evento inicial para preparar botones de la UI móvil y de cambio de vista.
 */
document.addEventListener('DOMContentLoaded', () => {
    const mapa = document.getElementById("map");
    if (mapa) {
        toggleMapMobile();
        toggleListView();
        updateViewToggleButtonLabel();
    }
});

/**
 * Activa el botón de mostrar el mapa en dispositivos móviles.
 */
const toggleMapMobile = () => {
    let openBtn = document.getElementById('open-map-btn');
    let activitiesContainer = document.querySelector('.activities-container');
    if (!openBtn || !activitiesContainer) return;
    activitiesContainer.classList.remove('displayed');
    openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        activitiesContainer.classList.toggle('displayed');
    });
};

/**
 * Activa el botón para cambiar entre listado y mapa (vista de escritorio/tablet).
 */
const toggleListView = () => {
    let toggleViewBtn = document.getElementById('change-view-btn');
    let map = document.getElementById('map');
    let activitiesContainer = document.querySelector('.list-container');
    let activitiesRoot = document.querySelector('.activities-container');
    if (!toggleViewBtn || !map) return;
    updateViewToggleButtonLabel();
    toggleViewBtn.addEventListener('click', () => {
        // Same expansion trigger used by "Ver Horas Santas" and map-pin popups.
        if (activitiesRoot && !activitiesRoot.classList.contains('displayed')) {
            activitiesRoot.classList.add('displayed');
        }
        if (map.classList.contains('hidden')) {
            // Si el mapa está oculto, mostrarlo y ocultar actividades
            map.classList.remove('hidden');
            activitiesContainer.classList.add('hidden');
        } else {
            // Si el mapa está visible, ocultarlo y mostrar actividades
            map.classList.add('hidden');
            activitiesContainer.classList.remove('hidden');
        }
        updateViewToggleButtonLabel();
    });
};

/**
 * Fuerza la vista expandida del mapa al abrir un popup desde un marcador.
 * Evita popups pequeños con scroll interno en móvil/tablet.
 */
const expandMapForPopup = (map, position) => {
    const activitiesContainer = document.querySelector('.activities-container');
    const mapElement = document.getElementById('map');
    const listContainer = document.querySelector('.list-container');

    if (activitiesContainer && !activitiesContainer.classList.contains('displayed')) {
        activitiesContainer.classList.add('displayed');
    }

    if (mapElement && mapElement.classList.contains('hidden')) {
        mapElement.classList.remove('hidden');
        if (listContainer) {
            listContainer.classList.add('hidden');
        }
        updateViewToggleButtonLabel();
    }

    window.setTimeout(() => {
        if (!map || typeof google === 'undefined' || !google.maps) return;
        google.maps.event.trigger(map, 'resize');
        if (position) {
            map.panTo(position);
        }
    }, 40);
};

const getViewToggleLabels = () => {
    const docLang = String(document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (docLang.startsWith('es')) {
        return {
            toList: 'VER LISTA',
            toMap: 'VER MAPA'
        };
    }
    return {
        toList: 'View in list',
        toMap: 'View on map'
    };
};

const updateViewToggleButtonLabel = () => {
    const toggleViewBtn = document.getElementById('change-view-btn');
    const map = document.getElementById('map');
    if (!toggleViewBtn || !map) return;
    const labels = getViewToggleLabels();
    const isMapHidden = map.classList.contains('hidden');
    const nextLabel = isMapHidden ? labels.toMap : labels.toList;
    const icon = isMapHidden ? getMapViewIcon() : getListViewIcon();
    toggleViewBtn.innerHTML = `${icon}<span class="hk-view-toggle__label">${nextLabel}</span>`;
    toggleViewBtn.setAttribute('aria-label', nextLabel);
};

const getListViewIcon = () => {
    return `<span class="hk-view-toggle__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
            <rect x="3" y="4" width="4" height="4" rx="1" stroke="currentColor" stroke-width="1.8"></rect>
            <rect x="3" y="10" width="4" height="4" rx="1" stroke="currentColor" stroke-width="1.8"></rect>
            <rect x="3" y="16" width="4" height="4" rx="1" stroke="currentColor" stroke-width="1.8"></rect>
            <path d="M10 6h11M10 12h11M10 18h11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>
        </svg>
    </span>`;
};

const getMapViewIcon = () => {
    return `<span class="hk-view-toggle__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
            <path d="M3 6.5l5-2 8 2 5-2v13l-5 2-8-2-5 2v-13z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"></path>
            <path d="M8 4.5v13M16 6.5v13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>
        </svg>
    </span>`;
};

const normalizeAgeGroupKey = (value) => {
    if (typeof value !== 'string') return '';
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, ' ');
};

const AGE_GROUP_ICON_BASE_BY_KEY = {
    'todos los grupos': 'Todos los grupos',
    'todos': 'Todos los grupos',
    'paratodos': 'Todos los grupos',
    'all groups': 'Todos los grupos',
    'all group': 'Todos los grupos',
    'all': 'Todos los grupos',
    'for all': 'Todos los grupos',
    'everyone': 'Todos los grupos',
    'everybody': 'Todos los grupos',
    'universitarios': 'Universitarios',
    'university students': 'Universitarios',
    'university student': 'Universitarios',
    'college students': 'Universitarios',
    'college student': 'Universitarios',
    'students': 'Universitarios',
    'profesionales': 'Profesionales',
    'professionals': 'Profesionales',
    'professional': 'Profesionales',
    'young professionals': 'Profesionales',
    'senior': 'Senior',
    'seniors': 'Senior',
    'frontera': 'Frontera',
    'frontier': 'Frontera',
    'border': 'Frontera',
    'kids': 'Kids',
    'wardians': 'Wardians',
    'donantes': 'Donantes',
    'donors': 'Donantes',
    'donor': 'Donantes',
    'opositores': 'Opositores',
    'opposition candidates': 'Opositores',
    'exam candidates': 'Opositores',
    'sacerdotes': 'Sacerdotes',
    'priests': 'Sacerdotes',
    'priest': 'Sacerdotes',
    'pringados': 'Pringados',
    'summit': 'Summit'
};

const AGE_GROUP_SPECIAL_ICON_BY_KEY = {
    'chico': 'figure.stand.svg',
    'chicos': 'figure.stand.svg',
    'chica': 'figure.stand.dress.svg',
    'chicas': 'figure.stand.dress.svg',
    'matrimonio': 'person.2.svg',
    'matrimonios': 'person.2.svg',
    'novios': 'person.2.svg',
    'novios y matrimonios': 'person.2.svg',
    'boy': 'figure.stand.svg',
    'boys': 'figure.stand.svg',
    'girl': 'figure.stand.dress.svg',
    'girls': 'figure.stand.dress.svg',
    'couples and marriage': 'person.2.svg',
    'married couples': 'person.2.svg',
    'couples and marriages': 'person.2.svg',
    'couple': 'person.2.svg',
    'couples': 'person.2.svg',
    'marriage': 'person.2.svg',
    'marriages': 'person.2.svg'
};

const getCanonicalAgeGroupIconBase = (label) => {
    const raw = typeof label === 'string' ? label.trim() : '';
    if (!raw) return '';
    const key = normalizeAgeGroupKey(raw);
    return AGE_GROUP_ICON_BASE_BY_KEY[key] || raw;
};

const getSpecialAgeGroupIcon = (label) => {
    const raw = typeof label === 'string' ? label.trim() : '';
    if (!raw) return null;
    const key = normalizeAgeGroupKey(raw);
    const file = AGE_GROUP_SPECIAL_ICON_BY_KEY[key];
    if (!file) return null;
    return {
        file,
        key
    };
};

/**
 * Espera a que la API de Google Maps esté cargada antes de inicializar el mapa.
 */
window.addEventListener('load', () => {
    if (typeof google === 'object' && typeof google.maps === 'object') {
        initMap();
    } else {
        console.error("Google Maps API no cargada correctamente.");
    }
});

/**
 * Función principal para inicializar el mapa, marcadores, clusters y sincronizar el listado.
 * - Usa la geolocalización si está permitida por el usuario, sino centra el mapa en el valor por defecto.
 * - Renderiza un listado completo de actividades, con buscador global.
 * - En Near Me ordena el listado por cercanía al usuario (si existe geolocalización).
 */
window.initMap = async function () {
    // Variables globales cargadas desde el backend (debe estar definido antes en el HTML)
    const ACTIVITY_TYPE = map_data.activity_type;
    const ACTIVITIES = map_data.activities;
    const isNearMePage = document.body?.classList?.contains('page-template-page_near');

    // Parámetros por defecto de inicialización
    let defaultCenter = { lat: Number(map_data.defaultLatAct), lng: Number(map_data.defaultLngAct) };
    let zoom = Number(map_data.defaultZoomAct);

    if ('Hora Santa' === ACTIVITY_TYPE || 'Compartiriado' === ACTIVITY_TYPE || 'Revolcadero' === ACTIVITY_TYPE) {
        defaultCenter = { lat: Number(map_data.defaultLat), lng: Number(map_data.defaultLng) };
        zoom = Number(map_data.defaultZoom);
    }

    let center = defaultCenter;

    let userLocation = null;

    if ('Hora Santa' === ACTIVITY_TYPE || 'Compartiriado' === ACTIVITY_TYPE || 'Revolcadero' === ACTIVITY_TYPE) {
        // Intenta obtener la geolocalización del usuario
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(
                    (pos) => {
                        resolve({
                            lat: pos.coords.latitude,
                            lng: pos.coords.longitude
                        });
                    },
                    (err) => reject(err),
                    {timeout: 5000}
                );
            });
            center = position;
            userLocation = position;
            zoom = Number(map_data.geoZoom);
        } catch (err) {
            // Si falla, centra el mapa en la posición por defecto
            console.warn("No se pudo obtener la geolocalización del usuario. Usando centro por defecto.");
        }
    }

    // Inicializa el mapa de Google
    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: zoom,
        center,
        disableDefaultUI: true,
        mapId: 'TU_MAP_ID' // Sustituir por el MapId real de Google si se usan estilos avanzados
    });

    // Si no hay actividades, muestra el mensaje y sale
    if (!ACTIVITIES || ACTIVITIES.length === 0) {
        const noDataDiv = document.getElementById('no-data-map');
        if (noDataDiv) noDataDiv.style.display = '';
        return;
    }

    // Rehidrata la lista con una estructura unificada y simple,
    // usando los mismos datos que las cards del mapa.
    renderUnifiedListCards(ACTIVITIES, ACTIVITY_TYPE);
    const listState = createListState(ACTIVITIES, { isNearMePage });
    ensureListSearchControl(listState, () => {
        applyListFiltersAndSorting(listState, {
            userLocation,
            fallbackCenter: center
        });
    });
    applyListFiltersAndSorting(listState, {
        userLocation,
        fallbackCenter: center
    });


    // =========================
    // Renderizado de marcadores avanzados
    // =========================

    const markerColor = getColorByActivityType(ACTIVITY_TYPE);
    const labels = getListCardLabels();
    let openInfoWindow = null;
    const markerEntries = [];
    let clustererInstance = null;

    // Bucle que añade cada marcador al mapa
    for (const activity of ACTIVITIES) {
        if (!activity?.HKN_Address__c?.latitude || !activity?.HKN_Address__c?.longitude) continue;

        const position = {
            lat: activity.HKN_Address__c.latitude,
            lng: activity.HKN_Address__c.longitude
        };

        // Selecciona el icono del marcador según grupo de edad o iniciales si es 'Compartiriado'
        const iconUrl = getIconByAgeGroup(activity.HKN_GrupoEdad__c);
        const markerIcon = ACTIVITY_TYPE === 'Compartiriado'
            ? getInitialLetters(markerColor, activity?.HKN_Proyecto__c ?? '')
            : await getCustomMarkerSVG(markerColor, iconUrl);

        // Crea el elemento HTML que será el contenido visual del marcador avanzado
        const div = document.createElement('div');
        const img = document.createElement('img');
        img.src = markerIcon;
        img.width = 51;
        img.height = 60;
        div.appendChild(img);

        // Crea el marcador avanzado en el mapa
        const marker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position,
            title: activity.Name,
            content: div
        });

        // Determina la imagen de la actividad y aplica fallback robusto.
        const imageSrc = getActivityImageData(activity, 'map').src;
        const detailUrl = resolveActivityCardUrl(activity, ACTIVITY_TYPE);
        const safeDetailUrl = escapeAttribute(sanitizeUrl(detailUrl) || '#');
        const detailLinkAttrs = getExternalLinkTargetAttrs(detailUrl);

        let infowindow;
        const fechaFormateada = formatearRangoFechas(activity.StartDate, activity.EndDate);
        const fechaEscapadaCompacta = formatearEscapadaCompacta(activity.StartDate, activity.EndDate);
        const coordinatorData = getCoordinatorData(activity);
        const coordinatorWhatsappUrl = buildCoordinatorWhatsAppUrl(activity, activity.Name);
        const locationCity = joinLocationParts(
            activity?.HKN_Address__c?.city,
            activity?.HKN_Address__c?.state,
            activity?.HKN_Address__c?.country
        );
        const locationStateCountry = joinLocationParts(
            activity?.HKN_Address__c?.state,
            activity?.HKN_Address__c?.country
        );
        const locationStreetStateCountry = joinLocationParts(
            activity?.HKN_Address__c?.street,
            activity?.HKN_Address__c?.state,
            activity?.HKN_Address__c?.country
        );

        const grupoEdadHTML = buildAgeGroupLabelsHTML(activity.HKN_GrupoEdad__c);
        // Plantillas de contenido según el tipo de actividad
        if ('Hora Santa' === ACTIVITY_TYPE) {
            const content = `
                <div data-activityId="${activity.Id}" class="card-map">
                    ${buildMapCardHero(imageSrc, activity.Name, detailUrl, grupoEdadHTML)}
                    <div class="card-map__body">
                    ${(activity.HKN_DiaCelebracion__c || activity.HKN_HoraCelebracion__c) ? `<p class="info date card-map__schedule">
                        ${activity.HKN_DiaCelebracion__c ? `<span class="card-map__schedule-day">${activity.HKN_DiaCelebracion__c}</span>` : ''}
                        ${activity.HKN_HoraCelebracion__c ? `<span class="card-map__schedule-time">${activity.HKN_HoraCelebracion__c}</span>` : ''}
                    </p>` : ''}
                    ${locationCity ? `<p class="info place">
                        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 5.62451C1 4.43104 1.47408 3.28645 2.31799 2.44254C3.16191 1.59863 4.30653 1.12451 5.5 1.12451C6.69347 1.12451 7.83809 1.59863 8.68201 2.44254C9.52592 3.28645 10 4.43104 10 5.62451C10 10.162 5.5 12.3745 5.5 12.3745C5.5 12.3745 1 10.162 1 5.62451Z" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.2" stroke-linejoin="round"/>
                            <path d="M5.5 6.74951C6.32843 6.74951 7 6.07794 7 5.24951C7 4.42108 6.32843 3.74951 5.5 3.74951C4.67157 3.74951 4 4.42108 4 5.24951C4 6.07794 4.67157 6.74951 5.5 6.74951Z" fill="${getColorByActivityType(ACTIVITY_TYPE)}"/>
                        </svg>
                        ${locationCity}
                    </p>` : ''}
                    ${coordinatorData.tel ? `<p class="info phone">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M11.0894 1H4.64882C4.20419 1 3.84375 1.32861 3.84375 1.73397V13.4774C3.84375 13.8828 4.20419 14.2114 4.64882 14.2114H11.0894C11.534 14.2114 11.8945 13.8828 11.8945 13.4774V1.73397C11.8945 1.32861 11.534 1 11.0894 1Z" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.09919" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11.8945 12.0977H3.84375" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.09919" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6.79688 2.32031H8.94373" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.09919" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="card-map__coordinator-inline">${coordinatorData.name ? `<span class="card-map__coordinator-name">${coordinatorData.name}:</span>` : ''}<a class="card-map__coordinator-phone" href="tel:${coordinatorData.tel}">${coordinatorData.tel}</a></span>
                    </p>` : ''}
                    ${activity.HKN_LinkWhatsapp__c ? `
                    <p class="info whatsapp">
                        <a class="map-whatsapp-btn" href="${activity.HKN_LinkWhatsapp__c}" target="_blank" rel="noopener">${escapeHtml(labels.whatsappGroup)}</a>
                    </p>` : ''}
                    </div>
                </div>`;
            infowindow = new google.maps.InfoWindow({ content, maxWidth: 380 });
        } else if ('Compartiriado' === ACTIVITY_TYPE) {
            const desc = stripTags(activity.HKN_Descripcion_Activ__c);
            const schedule = getRenderableSchedule(activity);
            const content = `
                <div data-activityId="${activity.Id}" class="card-map">
                    ${buildMapCardHero(imageSrc, activity.Name, detailUrl, grupoEdadHTML)}
                    <div class="card-map__body">
                    ${(schedule.day || schedule.time) ? `<p class="info date card-map__schedule">
                        ${schedule.day ? `<span class="card-map__schedule-day">${escapeHtml(schedule.day)}</span>` : ''}
                        ${schedule.time ? `<span class="card-map__schedule-time">${escapeHtml(schedule.time)}</span>` : ''}
                    </p>` : ''}
                    ${desc ? `<p class="info description">${desc}</p>` : ''}
                    ${coordinatorData.tel ? `<p class="info phone">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M11.0894 1H4.64882C4.20419 1 3.84375 1.32861 3.84375 1.73397V13.4774C3.84375 13.8828 4.20419 14.2114 4.64882 14.2114H11.0894C11.534 14.2114 11.8945 13.8828 11.8945 13.4774V1.73397C11.8945 1.32861 11.534 1 11.0894 1Z" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.09919" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11.8945 12.0977H3.84375" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.09919" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6.79688 2.32031H8.94373" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.09919" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="card-map__coordinator-inline">${coordinatorData.name ? `<span class="card-map__coordinator-name">${coordinatorData.name}:</span>` : ''}<a class="card-map__coordinator-phone" href="tel:${coordinatorData.tel}">${coordinatorData.tel}</a></span>
                    </p>` : ''}
                    ${coordinatorWhatsappUrl ? `<p class="info whatsapp info-whatsapp-contact">
                        <a class="map-whatsapp-btn map-whatsapp-btn--contact" href="${coordinatorWhatsappUrl}" target="_blank" rel="noopener">${escapeHtml(labels.whatsappContact)}</a>
                    </p>` : ''}
                    </div>
                </div>`;
            infowindow = new google.maps.InfoWindow({ content, maxWidth: 380 });
        } else if ('Revolcadero' === ACTIVITY_TYPE) {
            const content = `
                <div data-activityId="${activity.Id}" class="card-map">
                    ${buildMapCardHero(imageSrc, activity.Name, detailUrl, grupoEdadHTML)}
                    <div class="card-map__body">
                    ${locationCity ? `<p class="info place">
                        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 5.62451C1 4.43104 1.47408 3.28645 2.31799 2.44254C3.16191 1.59863 4.30653 1.12451 5.5 1.12451C6.69347 1.12451 7.83809 1.59863 8.68201 2.44254C9.52592 3.28645 10 4.43104 10 5.62451C10 10.162 5.5 12.3745 5.5 12.3745C5.5 12.3745 1 10.162 1 5.62451Z" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.2" stroke-linejoin="round"/>
                            <path d="M5.5 6.74951C6.32843 6.74951 7 6.07794 7 5.24951C7 4.42108 6.32843 3.74951 5.5 3.74951C4.67157 3.74951 4 4.42108 4 5.24951C4 6.07794 4.67157 6.74951 5.5 6.74951Z" fill="${getColorByActivityType(ACTIVITY_TYPE)}"/>
                        </svg>
                        ${locationCity}
                    </p>` : ''}
                    ${coordinatorData.tel ? `<p class="info phone">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M11.0894 1H4.64882C4.20419 1 3.84375 1.32861 3.84375 1.73397V13.4774C3.84375 13.8828 4.20419 14.2114 4.64882 14.2114H11.0894C11.534 14.2114 11.8945 13.8828 11.8945 13.4774V1.73397C11.8945 1.32861 11.534 1 11.0894 1Z" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.09919" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.8945 12.0977H3.84375" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.09919" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.79688 2.32031H8.94373" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.09919" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="card-map__coordinator-inline">${coordinatorData.name ? `<span class="card-map__coordinator-name">${coordinatorData.name}:</span>` : ''}<a class="card-map__coordinator-phone" href="tel:${coordinatorData.tel}">${coordinatorData.tel}</a></span>
                    </p>` : ''}
                    ${coordinatorWhatsappUrl ? `<p class="info whatsapp info-whatsapp-contact">
                        <a class="map-whatsapp-btn map-whatsapp-btn--contact" href="${coordinatorWhatsappUrl}" target="_blank" rel="noopener">${escapeHtml(labels.whatsappContact)}</a>
                    </p>` : ''}
                    </div>
                </div>`;
            infowindow = new google.maps.InfoWindow({ content, maxWidth: 380 });
        }  else if ('Novios y Matrimonios' === ACTIVITY_TYPE) {
            const content = `
                <div data-activityId="${activity.Id}" class="card-map">
                    ${buildMapCardHero(imageSrc, activity.Name, detailUrl, grupoEdadHTML)}
                    <div class="card-map__body">
                    ${fechaEscapadaCompacta ? `<p class="info date card-map__date-compact">${fechaEscapadaCompacta}</p>` : ''}
                    ${locationStreetStateCountry ? `<p class="info place">
                        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 5.62451C1 4.43104 1.47408 3.28645 2.31799 2.44254C3.16191 1.59863 4.30653 1.12451 5.5 1.12451C6.69347 1.12451 7.83809 1.59863 8.68201 2.44254C9.52592 3.28645 10 4.43104 10 5.62451C10 10.162 5.5 12.3745 5.5 12.3745C5.5 12.3745 1 10.162 1 5.62451Z" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.2" stroke-linejoin="round"/>
                            <path d="M5.5 6.74951C6.32843 6.74951 7 6.07794 7 5.24951C7 4.42108 6.32843 3.74951 5.5 3.74951C4.67157 3.74951 4 4.42108 4 5.24951C4 6.07794 4.67157 6.74951 5.5 6.74951Z" fill="${getColorByActivityType(ACTIVITY_TYPE)}"/>
                        </svg>
                        ${locationStreetStateCountry}
                    </p>` : ''}
                    ${activity?.HKN_Precio__c ? `<p class="info price">
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.85352 1.02075V17.98" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.2" stroke-linejoin="round"/>
                            <path d="M13.8749 11.0421H3.85352V3.33337H13.8749C14.0264 3.334 14.1745 3.37929 14.3004 3.46355C14.4264 3.54782 14.5247 3.66733 14.5831 3.80716C14.6415 3.94699 14.6572 4.10094 14.6286 4.24975C14.6 4.39856 14.5282 4.53565 14.4222 4.64387L11.886 7.18774L14.4222 9.72393C14.5309 9.83175 14.6051 9.96951 14.6352 10.1196C14.6653 10.2698 14.6501 10.4254 14.5914 10.5669C14.5326 10.7083 14.4331 10.829 14.3055 10.9136C14.1779 10.9983 14.028 11.043 13.8749 11.0421V11.0421Z" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.2" stroke-linejoin="round"/>
                        </svg>
                        ${activity.HKN_Precio__c}
                    </p>` : ''}
                    <p class="info cta"><a class="map-join-btn" href="${safeDetailUrl}"${detailLinkAttrs}>¡Apuntarme!</a></p>
                    </div>
                </div>`;
            infowindow = new google.maps.InfoWindow({ content, maxWidth: 380 });
        } else {
            const supportsJoinCta = ['Escapada', 'Retiro', 'Encuentro', 'Evento'].includes(ACTIVITY_TYPE);
            const content = `
                <div data-activityId="${activity.Id}" class="card-map">
                    ${buildMapCardHero(imageSrc, activity.Name, detailUrl, grupoEdadHTML)}
                    <div class="card-map__body">
                    ${supportsJoinCta
                        ? (fechaEscapadaCompacta ? `<p class="info date card-map__date-compact">${fechaEscapadaCompacta}</p>` : '')
                        : (fechaFormateada ? `<p class="info date">
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Icon/Date">
                            <rect id="Rectangle 25" x="2.375" y="4.75" width="14.25" height="11.875" rx="1.58333" stroke="${getColorByActivityType(ACTIVITY_TYPE)}"/>
                            <path id="Vector 3" d="M3.16602 8.70837H15.8327" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-linecap="round"/>
                            <path id="Line 1" d="M6.33398 2.375L6.33398 5.54167" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-linecap="round"/>
                            <path id="Line 2" d="M12.666 2.375L12.666 5.54167" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-linecap="round"/>
                            </g>
                        </svg>
                        ${fechaFormateada}
                        </p>` : '')}
                    ${locationStateCountry ? `<p class="info place">
                        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 5.62451C1 4.43104 1.47408 3.28645 2.31799 2.44254C3.16191 1.59863 4.30653 1.12451 5.5 1.12451C6.69347 1.12451 7.83809 1.59863 8.68201 2.44254C9.52592 3.28645 10 4.43104 10 5.62451C10 10.162 5.5 12.3745 5.5 12.3745C5.5 12.3745 1 10.162 1 5.62451Z" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.2" stroke-linejoin="round"/>
                            <path d="M5.5 6.74951C6.32843 6.74951 7 6.07794 7 5.24951C7 4.42108 6.32843 3.74951 5.5 3.74951C4.67157 3.74951 4 4.42108 4 5.24951C4 6.07794 4.67157 6.74951 5.5 6.74951Z" fill="${getColorByActivityType(ACTIVITY_TYPE)}"/>
                        </svg>
                        ${locationStateCountry}
                    </p>` : ''}
                    ${activity?.HKN_Precio__c ? `<p class="info price">
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.85352 1.02075V17.98" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.2" stroke-linejoin="round"/>
                            <path d="M13.8749 11.0421H3.85352V3.33337H13.8749C14.0264 3.334 14.1745 3.37929 14.3004 3.46355C14.4264 3.54782 14.5247 3.66733 14.5831 3.80716C14.6415 3.94699 14.6572 4.10094 14.6286 4.24975C14.6 4.39856 14.5282 4.53565 14.4222 4.64387L11.886 7.18774L14.4222 9.72393C14.5309 9.83175 14.6051 9.96951 14.6352 10.1196C14.6653 10.2698 14.6501 10.4254 14.5914 10.5669C14.5326 10.7083 14.4331 10.829 14.3055 10.9136C14.1779 10.9983 14.028 11.043 13.8749 11.0421V11.0421Z" stroke="${getColorByActivityType(ACTIVITY_TYPE)}" stroke-width="1.2" stroke-linejoin="round"/>
                        </svg>
                        ${activity.HKN_Precio__c}
                    </p>` : ''}
                    ${supportsJoinCta ? `<p class="info cta"><a class="map-join-btn" href="${safeDetailUrl}"${detailLinkAttrs}>¡Apuntarme!</a></p>` : ''}
                    </div>
                </div>`;
            infowindow = new google.maps.InfoWindow({ content, maxWidth: 380 });
        }

        // Evento para abrir la info ventana del marcador (y cerrar la anterior si había)
        marker.addListener("gmp-click", () => {
            if (openInfoWindow) openInfoWindow.close();
            expandMapForPopup(map, position);

            // Adding a small delay to allow the DOM to render first, and prevent click propagation to infoWindow inner links
            setTimeout(() => {
                infowindow.setPosition(position);
                infowindow.open({ map });
                openInfoWindow = infowindow;
            }, 10);
        });

        markerEntries.push({
            id: String(activity?.Id ?? '').trim(),
            marker,
            activity
        });
    }

    // Evento para cerrar cualquier ventana de info al hacer click en el mapa
    map.addListener("click", () => {
        if (openInfoWindow) {
            openInfoWindow.close();
            openInfoWindow = null;
        }
    });

    // Inicializa el agrupador de marcadores (clusters)
    const { MarkerClusterer, SuperClusterAlgorithm } = markerClusterer;
    const clusterAlgorithm = new SuperClusterAlgorithm({
        maxZoom: 15,
        radius: 80
    });
    const onClusterClick = (event, cluster, mapInstance) => {
            const activeMap = mapInstance || map;
            if (!activeMap || !cluster) return;

            if (openInfoWindow) {
                openInfoWindow.close();
                openInfoWindow = null;
            }

            const currentZoom = Number(activeMap.getZoom() || 0);
            const clusterSize = Array.isArray(cluster.markers) ? cluster.markers.length : 0;
            const zoomBoost = clusterSize >= 12 ? 3 : 2;
            const targetZoom = Math.min(19, Math.max(currentZoom + zoomBoost, 8));
            const clusterBounds = (cluster && typeof cluster.bounds === 'function')
                ? cluster.bounds()
                : cluster?.bounds;

            if (clusterBounds && typeof activeMap.fitBounds === 'function') {
                activeMap.fitBounds(clusterBounds, 56);
                window.setTimeout(() => {
                    const zoomAfterFit = Number(activeMap.getZoom() || 0);
                    if (zoomAfterFit < targetZoom) {
                        activeMap.setZoom(targetZoom);
                    }
                }, 70);
                return;
            }

            if (cluster?.position && typeof activeMap.panTo === 'function') {
                activeMap.panTo(cluster.position);
            }
            activeMap.setZoom(targetZoom);
    };

    const rebuildClusterer = (visibleMarkers = []) => {
        if (clustererInstance && typeof clustererInstance.clearMarkers === 'function') {
            clustererInstance.clearMarkers();
        }

        if (clustererInstance && typeof clustererInstance.setMap === 'function') {
            clustererInstance.setMap(null);
        }

        clustererInstance = new MarkerClusterer({
            map,
            markers: visibleMarkers,
            algorithm: clusterAlgorithm,
            onClusterClick
        });
    };

    const applyActivitiesFilters = (criteria = {}) => {
        const filteredActivities = filterActivitiesByFormCriteria(ACTIVITIES, criteria, ACTIVITY_TYPE);
        const visibleIds = new Set(
            filteredActivities
                .map((activity) => String(activity?.Id ?? '').trim())
                .filter(Boolean)
        );
        const visibleMarkers = [];

        if (openInfoWindow) {
            openInfoWindow.close();
            openInfoWindow = null;
        }

        markerEntries.forEach((entry) => {
            const shouldShow = visibleIds.has(entry.id);
            entry.marker.map = shouldShow ? map : null;
            if (shouldShow) {
                visibleMarkers.push(entry.marker);
            }
        });

        rebuildClusterer(visibleMarkers);

        listState.activities = filteredActivities.slice();
        listState.searchIndex = buildActivitiesSearchIndex(listState.activities);
        applyListFiltersAndSorting(listState, {
            userLocation,
            fallbackCenter: center
        });

        return filteredActivities;
    };

    window.hkActivitiesApplyFilters = (criteria = {}) => {
        return applyActivitiesFilters(criteria);
    };

    rebuildClusterer(markerEntries.map((entry) => entry.marker));

    const initialCriteria = readFilterCriteriaFromDom();
    if (initialCriteria) {
        applyActivitiesFilters(initialCriteria);
    }

};


// ===========================================================================
// FUNCIONES AUXILIARES PARA ICONOS, ORDENACIÓN Y FORMATO
// ===========================================================================

/**
 * Renderiza la cabecera visual de la card del mapa.
 * Mantiene la imagen como hero de ancho completo con overlay + título encima.
 */
function getMapPlaceholderUrl(context = 'activities_card') {
    const placeholders = (
        typeof map_data === 'object'
        && map_data !== null
        && typeof map_data.placeholders === 'object'
        && map_data.placeholders !== null
    ) ? map_data.placeholders : {};

    const orderedKeys = [context, 'activities_card', 'activities_detail'];
    for (const key of orderedKeys) {
        const candidate = sanitizeUrl(String(placeholders?.[key] || '').trim());
        if (candidate) {
            return candidate;
        }
    }

    return `${window.location.origin}/wp-content/plugins/hakuna-extras/assets/img/placeholder.png`;
}

function buildMapCardHero(imageSrc, title, href = '', ageGroupsHTML = '') {
    const groups = ageGroupsHTML
        ? `<div class="card-map__hero-age-groups">${ageGroupsHTML}</div>`
        : '';
    const isPlaceholder = isMapPlaceholderImage(imageSrc);
    const heroClass = isPlaceholder ? ' card-map__hero--placeholder' : '';
    const imageClass = isPlaceholder
        ? 'card-map__hero-image card-map__hero-image--placeholder'
        : 'card-map__hero-image';
    const safeImageSrc = escapeAttribute(imageSrc);
    const safeFallbackSrc = escapeAttribute(getMapPlaceholderUrl('activities_card'));
    const safeTitle = escapeHtml(title || '');

    const hero = `
        <div class="card-map__hero${heroClass}">
            <img src="${safeImageSrc}" alt="" class="${imageClass}" onerror="this.onerror=null;this.src='${safeFallbackSrc}';"/>
            <span class="card-map__hero-overlay" aria-hidden="true"></span>
            <div class="card-map__hero-content">
                <p class="title card-map__hero-title">${safeTitle}</p>
                ${groups}
            </div>
        </div>
    `;

    const safeHref = sanitizeUrl(href);
    if (!safeHref) {
        return hero;
    }

    const targetAttrs = getExternalLinkTargetAttrs(safeHref);
    return `<a class="card-map__hero-link" href="${escapeAttribute(safeHref)}"${targetAttrs}>${hero}</a>`;
}

function isMapPlaceholderImage(src) {
    const value = String(src || '').toLowerCase();
    if (!value) return true;
    return (
        value.includes('img-placeholder') ||
        value.includes('placeholder-generico') ||
        value.includes('placeholder.png') ||
        value.includes('placeholder.webp')
    );
}

function renderUnifiedListCards(activities, activityType) {
    const container = document.getElementById('contenedor-listado');
    if (!container || !Array.isArray(activities)) return;

    const existingItems = new Map(
        Array.from(container.querySelectorAll('[data-activityId-list]'))
            .map(node => [String(node.getAttribute('data-activityId-list') || ''), node])
    );
    const renderedIds = new Set();

    activities.forEach(activity => {
        const activityId = String(activity?.Id ?? '').trim();
        if (!activityId) return;
        renderedIds.add(activityId);

        let item = existingItems.get(activityId);
        if (!item) {
            item = document.createElement('div');
            item.setAttribute('data-activityId-list', activityId);
            container.appendChild(item);
        }

        item.className = 'activity hk-list-card-item';
        item.innerHTML = buildUnifiedListCardMarkup(activity, activityType);
    });

    existingItems.forEach((node, id) => {
        if (!renderedIds.has(id)) {
            node.remove();
        }
    });

    markLowResolutionListThumbs(container);
}

function markLowResolutionListThumbs(scope = document) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;

    const thumbs = scope.querySelectorAll('.hk-list-card__thumb');
    if (!thumbs.length) return;

    const lowResMaxWidth = 460;
    const lowResMaxHeight = 220;

    const getLumaStats = (ctx, startX, endX, height) => {
        let sum = 0;
        let sumSq = 0;
        let count = 0;
        for (let x = startX; x < endX; x += 1) {
            const column = ctx.getImageData(x, 0, 1, height).data;
            for (let i = 0; i < column.length; i += 4) {
                const luma = (0.2126 * column[i]) + (0.7152 * column[i + 1]) + (0.0722 * column[i + 2]);
                sum += luma;
                sumSq += luma * luma;
                count += 1;
            }
        }
        if (!count) {
            return { mean: 0, variance: 0 };
        }
        const mean = sum / count;
        const variance = Math.max(0, (sumSq / count) - (mean * mean));
        return { mean, variance };
    };

    const hasFramedSides = (img) => {
        if (!img || !img.naturalWidth || !img.naturalHeight) return false;
        if (img.naturalWidth < 720 || img.naturalHeight < 240) return false;
        if (img.dataset.hkFramedChecked === '1') {
            return img.dataset.hkFramedSides === '1';
        }

        const sampleWidth = 64;
        const sampleHeight = 20;
        const canvas = document.createElement('canvas');
        canvas.width = sampleWidth;
        canvas.height = sampleHeight;
        const ctx = canvas.getContext('2d');
        if (!ctx) return false;

        try {
            ctx.drawImage(img, 0, 0, sampleWidth, sampleHeight);
            const edgeBand = 6;
            const centerStart = Math.floor((sampleWidth - 16) / 2);
            const centerEnd = centerStart + 16;

            const left = getLumaStats(ctx, 0, edgeBand, sampleHeight);
            const right = getLumaStats(ctx, sampleWidth - edgeBand, sampleWidth, sampleHeight);
            const center = getLumaStats(ctx, centerStart, centerEnd, sampleHeight);

            const edgeVariance = Math.max(left.variance, right.variance);
            const edgesSimilar = Math.abs(left.mean - right.mean) <= 18;
            const centerHasTexture = center.variance >= edgeVariance + 55;
            const centerDiffers = (
                Math.abs(center.mean - left.mean) >= 10
                || Math.abs(center.mean - right.mean) >= 10
            );

            const framed = edgeVariance <= 28 && edgesSimilar && centerHasTexture && centerDiffers;
            img.dataset.hkFramedChecked = '1';
            img.dataset.hkFramedSides = framed ? '1' : '0';
            return framed;
        } catch (error) {
            img.dataset.hkFramedChecked = '1';
            img.dataset.hkFramedSides = '0';
            return false;
        }
    };

    const applyLowResState = (img) => {
        if (!img) return;
        const naturalWidth = Number(img.naturalWidth || 0);
        const naturalHeight = Number(img.naturalHeight || 0);
        if (!Number.isFinite(naturalWidth) || naturalWidth <= 0) return;

        const isLowRes = (
            naturalWidth <= lowResMaxWidth
            || (naturalWidth <= 680 && naturalHeight > 0 && naturalHeight <= lowResMaxHeight)
        );
        const isHighRes = !isLowRes && naturalWidth >= 960;
        const isFramed = !isLowRes && hasFramedSides(img);

        const link = img.closest('.hk-list-card__thumb-link');
        const card = img.closest('.hk-list-card');
        if (link) {
            link.classList.toggle('hk-list-card__thumb-link--low-res', isLowRes);
        }
        if (card) {
            card.classList.toggle('hk-list-card--low-res-thumb', isLowRes);
            card.classList.toggle('hk-list-card--high-res-thumb', isHighRes);
            card.classList.toggle('hk-list-card--framed-thumb', isFramed);
        }
        img.classList.toggle('hk-list-card__thumb--low-res', isLowRes);
        img.classList.toggle('hk-list-card__thumb--hi-res', isHighRes);
        img.classList.toggle('hk-list-card__thumb--framed', isFramed);
    };

    thumbs.forEach((img) => {
        if (!img) return;

        if (img.dataset.hkLowResBound !== '1') {
            img.dataset.hkLowResBound = '1';
            img.addEventListener('load', () => applyLowResState(img));
            img.addEventListener('error', () => applyLowResState(img));
        }

        if (img.complete) {
            applyLowResState(img);
        }
    });
}

function buildUnifiedListCardMarkup(activity, activityType) {
    const labels = getListCardLabels();
    const accentColor = getColorByActivityType(activityType);
    const detailUrl = resolveActivityCardUrl(activity, activityType);
    const imageData = getActivityImageData(activity, 'list');
    const imageSrc = imageData.src;
    const title = escapeHtml(activity?.Name || '');

    const coordinator = getCoordinatorData(activity);
    const coordinatorWhatsappUrl = buildCoordinatorWhatsAppUrl(activity, activity?.Name || '');

    const locationCity = joinLocationParts(
        activity?.HKN_Address__c?.city,
        activity?.HKN_Address__c?.state,
        activity?.HKN_Address__c?.country
    );
    const locationStateCountry = joinLocationParts(
        activity?.HKN_Address__c?.state,
        activity?.HKN_Address__c?.country
    );
    const locationStreetStateCountry = joinLocationParts(
        activity?.HKN_Address__c?.street,
        activity?.HKN_Address__c?.state,
        activity?.HKN_Address__c?.country
    );

    const dateRange = formatearRangoFechas(activity?.StartDate, activity?.EndDate);
    const dateCompact = formatearEscapadaCompacta(activity?.StartDate, activity?.EndDate);
    const ageGroupsHTML = buildAgeGroupLabelsHTML(activity?.HKN_GrupoEdad__c);
    const schedule = getRenderableSchedule(activity);

    const metaRows = [];
    const actions = [];
    let hasJoinAction = false;
    let compactDateHeader = '';
    let highlightedSchedule = '';
    const supportsJoinCta = ['Escapada', 'Retiro', 'Encuentro', 'Evento'].includes(activityType);

    if ('Hora Santa' === activityType) {
        if (activity?.HKN_DiaCelebracion__c || activity?.HKN_HoraCelebracion__c) {
            highlightedSchedule = `
                <div class="hk-list-card__schedule">
                    ${activity?.HKN_DiaCelebracion__c ? `<span class="hk-list-card__schedule-day">${escapeHtml(activity.HKN_DiaCelebracion__c)}</span>` : ''}
                    ${activity?.HKN_HoraCelebracion__c ? `<span class="hk-list-card__schedule-time">${escapeHtml(activity.HKN_HoraCelebracion__c)}</span>` : ''}
                </div>
            `;
        }
        metaRows.push(buildListMetaRow(labels.location, locationCity));
        if (coordinator?.tel) {
            metaRows.push(buildListMetaRow(
                labels.coordinator,
                `${coordinator.name ? `${coordinator.name}: ` : ''}${coordinator.tel}`,
                `tel:${coordinator.tel}`
            ));
        }
        if (activity?.HKN_LinkWhatsapp__c) {
            actions.push(buildListButton(activity.HKN_LinkWhatsapp__c, labels.whatsappGroup, 'outline'));
            hasJoinAction = true;
        }
    } else if ('Revolcadero' === activityType) {
        metaRows.push(buildListMetaRow(labels.location, locationCity));
        if (coordinator?.tel) {
            metaRows.push(buildListMetaRow(
                labels.coordinator,
                `${coordinator.name ? `${coordinator.name}: ` : ''}${coordinator.tel}`,
                `tel:${coordinator.tel}`
            ));
        }
        if (coordinatorWhatsappUrl) {
            actions.push(buildListButton(coordinatorWhatsappUrl, labels.whatsappContact, 'outline'));
            hasJoinAction = true;
        }
    } else if ('Compartiriado' === activityType) {
        if (schedule.day || schedule.time) {
            highlightedSchedule = `
                <div class="hk-list-card__schedule">
                    ${schedule.day ? `<span class="hk-list-card__schedule-day">${escapeHtml(schedule.day)}</span>` : ''}
                    ${schedule.time ? `<span class="hk-list-card__schedule-time">${escapeHtml(schedule.time)}</span>` : ''}
                </div>
            `;
        }

        const description = truncateText(stripTags(activity?.HKN_Descripcion_Activ__c), 210);
        if (description) {
            metaRows.push(`<p class="hk-list-card__description">${escapeHtml(description)}</p>`);
        }
        if (coordinator?.tel) {
            metaRows.push(buildListMetaRow(
                labels.coordinator,
                `${coordinator.name ? `${coordinator.name}: ` : ''}${coordinator.tel}`,
                `tel:${coordinator.tel}`
            ));
        }
        if (coordinatorWhatsappUrl) {
            actions.push(buildListButton(coordinatorWhatsappUrl, labels.whatsappContact, 'outline'));
            hasJoinAction = true;
        }
    } else if ('Novios y Matrimonios' === activityType) {
        if (dateCompact) {
            compactDateHeader = `<div class="hk-list-card__thumb-date">${dateCompact}</div>`;
        } else if (dateRange) {
            metaRows.push(buildListMetaRow(labels.date, dateRange));
        }
        metaRows.push(buildListMetaRow(labels.location, locationStreetStateCountry));
        if (activity?.HKN_Precio__c) {
            metaRows.push(buildListMetaRow(labels.price, activity.HKN_Precio__c));
        }
        actions.push(buildListButton(detailUrl, labels.join, 'solid'));
        hasJoinAction = true;
    } else {
        if (supportsJoinCta) {
            if (dateCompact) {
                compactDateHeader = `<div class="hk-list-card__thumb-date">${dateCompact}</div>`;
            } else if (dateRange) {
                metaRows.push(buildListMetaRow(labels.date, dateRange));
            }
        } else if (dateRange) {
            metaRows.push(buildListMetaRow(labels.date, dateRange));
        }
        metaRows.push(buildListMetaRow(labels.location, locationStateCountry));
        if (activity?.HKN_Precio__c) {
            metaRows.push(buildListMetaRow(labels.price, activity.HKN_Precio__c));
        }
        if (supportsJoinCta) {
            actions.push(buildListButton(detailUrl, labels.join, 'solid'));
            hasJoinAction = true;
        }
    }

    const meta = metaRows.filter(Boolean).join('');
    const actionsHTML = actions.length ? `<div class="hk-list-card__actions">${actions.join('')}</div>` : '';
    const safeDetailUrl = escapeAttribute(sanitizeUrl(detailUrl) || '#');
    const detailLinkAttrs = getExternalLinkTargetAttrs(detailUrl);
    const safeImageSrc = escapeAttribute(imageSrc);
    const safeImageSrcSet = imageData.srcset ? escapeAttribute(imageData.srcset) : '';
    const safeImageSizes = imageData.sizes ? escapeAttribute(imageData.sizes) : '';
    const imageFallbackSrc = escapeAttribute(getMapPlaceholderUrl('activities_card'));
    const imageResponsiveAttrs = safeImageSrcSet
        ? ` srcset="${safeImageSrcSet}" sizes="${safeImageSizes}"`
        : '';
    const thumbAgeGroups = ageGroupsHTML
        ? `<div class="hk-list-card__thumb-age-groups">${ageGroupsHTML}</div>`
        : '';
    const thumbHeader = compactDateHeader
        ? `<div class="hk-list-card__thumb-header">${compactDateHeader}</div>`
        : '';
    const thumbOverlayContent = (
        activityType === 'Compartiriado'
            ? [highlightedSchedule, thumbAgeGroups]
            : [thumbAgeGroups, highlightedSchedule]
    ).filter(Boolean).join('');
    const thumbOverlay = thumbOverlayContent
        ? `<div class="hk-list-card__thumb-overlay">${thumbOverlayContent}</div>`
        : '';
    const cardTypeClass = getActivityTypeSlug(activityType);

    return `
        <article class="hk-list-card hk-list-card--type-${escapeAttribute(cardTypeClass)}${hasJoinAction ? ' hk-list-card--with-join' : ''}" style="--hk-list-accent: ${escapeAttribute(accentColor)};">
            <a class="hk-list-card__thumb-link" href="${safeDetailUrl}"${detailLinkAttrs}>
                <img src="${safeImageSrc}"${imageResponsiveAttrs} alt="${title}" class="hk-list-card__thumb ${isMapPlaceholderImage(imageSrc) ? 'hk-list-card__thumb--placeholder' : ''}" loading="lazy" onerror="this.onerror=null;this.src='${imageFallbackSrc}';this.srcset='';" />
                ${thumbHeader}
                ${thumbOverlay}
            </a>
            <div class="hk-list-card__content">
                <h3 class="hk-list-card__title"><a href="${safeDetailUrl}"${detailLinkAttrs}>${title}</a></h3>
                <div class="hk-list-card__meta">${meta}</div>
                ${actionsHTML}
            </div>
        </article>
    `;
}

function getActivityTypeSlug(activityType) {
    return String(activityType || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        || 'generic';
}

function buildListMetaRow(label, value, href = '') {
    const safeLabel = escapeHtml(label || '');
    const safeValue = escapeHtml(value || '');
    if (!safeValue) return '';

    const safeHref = sanitizeUrl(href);
    const valueMarkup = safeHref
        ? `<a href="${escapeAttribute(safeHref)}">${safeValue}</a>`
        : `<span>${safeValue}</span>`;

    return `
        <p class="hk-list-card__meta-item">
            <span class="hk-list-card__meta-label">${safeLabel}</span>
            <span class="hk-list-card__meta-value">${valueMarkup}</span>
        </p>
    `;
}

function buildListButton(url, label, variant = 'outline') {
    const safeHref = sanitizeUrl(url);
    if (!safeHref) return '';
    const safeLabel = escapeHtml(label || '');
    const variantClass = variant === 'solid' ? 'hk-list-card__btn--solid' : 'hk-list-card__btn--outline';
    const targetAttrs = getExternalLinkTargetAttrs(safeHref);
    return `<a class="hk-list-card__btn ${variantClass}" href="${escapeAttribute(safeHref)}"${targetAttrs}>${safeLabel}</a>`;
}

function getExternalLinkTargetAttrs(url = '') {
    const safeHref = sanitizeUrl(url);
    if (!safeHref || !/^https?:/i.test(safeHref)) {
        return '';
    }

    try {
        const parsed = new URL(safeHref, window.location.origin);
        return parsed.origin !== window.location.origin
            ? ' target="_blank" rel="noopener"'
            : '';
    } catch (error) {
        return '';
    }
}

function buildAgeGroupLabelsHTML(rawGroups = '') {
    const groups = getDisplayAgeGroups(rawGroups);
    if (!Array.isArray(groups) || !groups.length) return '';

    return groups.map(group => {
        if (!group) return '';
        const homeUrl = map_data?.homeUrl || window.location.origin;
        const specialIcon = getSpecialAgeGroupIcon(group);
        let iconSvg = '';
        let iconWebp = '';
        let iconClass = 'icon';

        if (specialIcon) {
            iconSvg = `${homeUrl}/wp-content/plugins/hakuna-extras/assets/icons/apple-icons/${specialIcon.file}`;
            iconClass = `icon icon--apple icon--apple-${specialIcon.key}`;
        } else {
            const canonicalName = getCanonicalAgeGroupIconBase(group);
            const fileBase = encodeURIComponent(canonicalName).replace(/%2F/g, '/');
            iconSvg = `${homeUrl}/wp-content/themes/compi/patterns/img/age-group-icons/${fileBase}-n-age-map-card.svg`;
            iconWebp = `${homeUrl}/wp-content/themes/compi/patterns/img/age-group-icons/${fileBase}-n-age-map-card.webp`;
        }

        const onErrorAttr = iconWebp
            ? ` onerror="this.onerror=null;this.src='${iconWebp}';"`
            : '';
        return `
            <span class="age-group-label">
                <img src="${iconSvg}" alt="" aria-hidden="true" class="${iconClass}"${onErrorAttr} />
                <span class="label">${escapeHtml(group.toUpperCase())}</span>
            </span>
        `;
    }).join('');
}

function buildActivityDetailUrl(activityId, activityType = (map_data?.activity_type ?? '')) {
    const id = String(activityId || '').trim();
    if (!id) return '#';
    activityType = String(activityType || '');
    const basePath = `${window.location.origin}${window.location.pathname}`;
    const isNearMeType = isNearMeActivityType(activityType);
    const looksLikeNearMePath = isNearMeContextPath(window.location.pathname);
    const cleanBase = basePath.replace(/\/+$/, '');

    if (isNearMeType || looksLikeNearMePath) {
        return `${cleanBase}/${encodeURIComponent(id)}/`;
    }

    return `${cleanBase}/${encodeURIComponent(id)}/`;
}

function normalizeRoutingText(value = '') {
    return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, ' ');
}

function isSoulCollegeExternalUrl(url = '') {
    const safeUrl = sanitizeUrl(url);
    if (!safeUrl) return false;

    try {
        const parsed = new URL(safeUrl, window.location.origin);
        const protocol = String(parsed.protocol || '').toLowerCase();
        if (protocol !== 'http:' && protocol !== 'https:') {
            return false;
        }
        const host = String(parsed.hostname || '').toLowerCase();
        return host === 'soulcollege.com' || host.endsWith('.soulcollege.com');
    } catch (error) {
        return false;
    }
}

function isNoviosMatrimoniosActivityType(activityType = '', activity = null) {
    const sources = [
        activityType,
        activity?.HKN_TipoActividad__c,
        activity?.HKN_SubTipoActividad__c,
        activity?.HKN_Proyecto__c,
        activity?.Name
    ];

    return sources.some((source) => {
        const normalized = normalizeRoutingText(source);
        if (!normalized) return false;
        return (
            normalized.includes('novios y matrimonios') ||
            (normalized.includes('novios') && normalized.includes('matrimonios')) ||
            normalized.includes('curso de novios') ||
            normalized.includes('master prematrimonial') ||
            normalized.includes('prematrimonial') ||
            normalized.includes('premarital') ||
            normalized.includes('couples and marriages') ||
            normalized.includes('couples and marriage')
        );
    });
}

function isSoulWeekRetreatActivity(activity, activityType = '') {
    const normalizedType = normalizeRoutingText(activityType || activity?.HKN_TipoActividad__c);
    const isRetreatType = normalizedType.includes('retiro') || normalizedType.includes('retreat');
    if (!isRetreatType) return false;

    const soulWeekSources = [
        activity?.HKN_SubTipoActividad__c,
        activity?.HKN_Proyecto__c,
        activity?.Name
    ];

    return soulWeekSources.some((source) => normalizeRoutingText(source).includes('soul week'));
}

function shouldBypassSingleForExternal(activity, activityType = '', externalUrl = '') {
    if (!activity || !externalUrl) return false;

    // For these formats we always send cards to the external registration URL.
    if (isNoviosMatrimoniosActivityType(activityType, activity)) return true;
    if (isSoulWeekRetreatActivity(activity, activityType)) return true;

    // Extra safeguard: legacy Soul College links also bypass single.
    if (isSoulCollegeExternalUrl(externalUrl)) return true;
    return false;
}

function resolveActivityCardUrl(activity, activityType = (map_data?.activity_type ?? '')) {
    const fallbackUrl = buildActivityDetailUrl(activity?.Id, activityType);
    if (isNearMeActivityType(activityType) || isNearMeContextPath(window.location.pathname)) {
        return fallbackUrl;
    }

    const externalUrl = sanitizeUrl(String(activity?.HKN_LinkExterno__c || '').trim());
    if (shouldBypassSingleForExternal(activity, activityType, externalUrl)) {
        return externalUrl;
    }
    return fallbackUrl;
}

function isNearMeActivityType(activityType = '') {
    const normalizedType = String(activityType || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    return (
        normalizedType.includes('hora santa') ||
        normalizedType.includes('holy hour') ||
        normalizedType.includes('revolcadero') ||
        normalizedType.includes('compartiriado') ||
        normalizedType.includes('compartir')
    );
}

function isNearMeContextPath(pathname = window.location.pathname) {
    return /\/(horas-santas|holy-hours|revolcaderos|compartiriados|near-me|cerca-de-mi)(\/|$)/i.test(String(pathname || ''));
}

function getActivityImageData(activity, context = 'list') {
    const placeholderContext = (context === 'list' || context === 'map')
        ? 'activities_card'
        : 'activities_detail';
    const placeholder = getMapPlaceholderUrl(placeholderContext);
    const originalSrc = sanitizeUrl(String(activity?.HKN_Link_Imagen_Actividad_Original__c || '').trim());
    const mapSrc = sanitizeUrl(String(activity?.HKN_Link_Imagen_Actividad__c || '').trim());
    const listSrc = sanitizeUrl(String(activity?.HKN_Link_Imagen_Actividad_List__c || '').trim());
    const list2xSrc = sanitizeUrl(String(activity?.HKN_Link_Imagen_Actividad_List_2x__c || '').trim());
    const bannerSrc = sanitizeUrl(String(activity?.HKN_Link_Imagen_Actividad_Banner__c || '').trim());

    if (context !== 'list') {
        const preferredSrc = [mapSrc, listSrc, list2xSrc, bannerSrc, originalSrc]
            .find(url => url && !isMapPlaceholderImage(url));
        return {
            src: preferredSrc || placeholder,
            srcset: '',
            sizes: ''
        };
    }

    const addCandidate = (registry, width, url) => {
        if (!url || isMapPlaceholderImage(url) || !Number.isFinite(width)) return;
        if (!registry.has(width)) {
            registry.set(width, url);
        }
    };

    const candidatesByWidth = new Map();
    addCandidate(candidatesByWidth, 2200, originalSrc);
    addCandidate(candidatesByWidth, 1950, bannerSrc);
    addCandidate(candidatesByWidth, 300, listSrc);
    addCandidate(candidatesByWidth, 600, list2xSrc);
    addCandidate(candidatesByWidth, 300, mapSrc);

    const sortedCandidates = Array.from(candidatesByWidth.entries())
        .sort((a, b) => a[0] - b[0]);

    const srcset = sortedCandidates
        .map(([width, url]) => `${url} ${width}w`)
        .join(', ');

    const src = (
        [bannerSrc, originalSrc, list2xSrc, listSrc, mapSrc]
            .find(url => url && !isMapPlaceholderImage(url))
        || placeholder
    );

    return {
        src,
        srcset,
        sizes: '(max-width: 768px) calc(100vw - 48px), (max-width: 1192px) calc(100vw - 80px), calc((100vw - 48px) / 2)'
    };
}

function getListCardLabels() {
    const docLang = String(document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (docLang.startsWith('es')) {
        return {
            date: 'Fecha',
            location: 'Ubicación',
            coordinator: 'Coordinador',
            price: 'Precio',
            join: '¡Apuntarme!',
            whatsappGroup: 'GRUPO WHATSAPP',
            whatsappContact: 'CONTACTAR POR WHATSAPP'
        };
    }
    return {
        date: 'Date',
        location: 'Location',
        coordinator: 'Coordinator',
        price: 'Price',
        join: 'JOIN',
        whatsappGroup: 'WHATSAPP GROUP',
        whatsappContact: 'CONTACT ON WHATSAPP'
    };
}

function getListSearchLabels() {
    const docLang = String(document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (docLang.startsWith('es')) {
        return {
            placeholder: 'Buscar por nombre, ciudad, grupo de edad...',
            noResults: 'No hay actividades que coincidan con tu búsqueda.',
            noActivities: 'No hay actividades disponibles en este momento.'
        };
    }
    return {
        placeholder: 'Search by name, city, age group...',
        noResults: 'No activities match your search.',
        noActivities: 'There are no activities available right now.'
    };
}

function createListState(activities, options = {}) {
    return {
        activities: Array.isArray(activities) ? activities.slice() : [],
        searchIndex: buildActivitiesSearchIndex(activities),
        searchTerm: '',
        isNearMePage: Boolean(options?.isNearMePage),
        noActivitiesElement: document.getElementById('no-activities-message'),
        labels: getListSearchLabels()
    };
}

function ensureListSearchControl(listState, onSearchChange) {
    const listContainer = document.querySelector('.list-container');
    const list = document.getElementById('contenedor-listado');
    if (!listContainer || !list) return;

    let wrapper = listContainer.querySelector('.hk-list-search');
    if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'hk-list-search';
        wrapper.innerHTML = `
            <input
                type="search"
                class="hk-list-search__input"
                autocomplete="off"
                placeholder="${escapeAttribute(listState.labels.placeholder)}"
                aria-label="${escapeAttribute(listState.labels.placeholder)}"
            />
        `;
        listContainer.insertBefore(wrapper, list);
    }

    const input = wrapper.querySelector('.hk-list-search__input');
    if (!input || input.dataset.hkBound === '1') return;

    input.dataset.hkBound = '1';
    input.value = listState.searchTerm || '';
    input.addEventListener('input', (event) => {
        listState.searchTerm = String(event?.target?.value || '').trim();
        if (typeof onSearchChange === 'function') {
            onSearchChange();
        }
    });
}

function applyListFiltersAndSorting(listState, options = {}) {
    if (!listState || !Array.isArray(listState.activities)) return;

    let activities = listState.activities.slice();
    if (listState.isNearMePage) {
        const referencePoint = getListReferencePoint(options.userLocation, options.fallbackCenter);
        activities = ordenarPorDistancia(referencePoint, activities);
    }

    const filtered = filterActivitiesBySearch(activities, listState.searchTerm, listState.searchIndex);
    const visibleIds = new Set(filtered.map(activity => String(activity?.Id ?? '').trim()));
    const listContainer = document.getElementById('contenedor-listado');
    const nodes = listContainer
        ? listContainer.querySelectorAll('[data-activityId-list]')
        : [];

    nodes.forEach((node) => {
        const id = String(node.getAttribute('data-activityId-list') || '').trim();
        if (visibleIds.has(id)) {
            node.style.removeProperty('display');
            return;
        }
        node.style.setProperty('display', 'none', 'important');
    });

    reordenarListado(filtered);
    updateNoActivitiesMessage(listState, filtered.length);
}

function updateNoActivitiesMessage(listState, visibleCount) {
    const messageEl = listState?.noActivitiesElement;
    if (!messageEl) return;

    if (visibleCount > 0) {
        messageEl.style.display = 'none';
        return;
    }

    const hasSearch = Boolean(String(listState.searchTerm || '').trim());
    messageEl.textContent = hasSearch ? listState.labels.noResults : listState.labels.noActivities;
    messageEl.style.display = '';
}

function getListReferencePoint(userLocation, fallbackCenter) {
    const candidate = userLocation || fallbackCenter;
    const lat = Number(candidate?.lat);
    const lng = Number(candidate?.lng);
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
        return { lat, lng };
    }
    return { lat: 40.4380986, lng: -3.8443436 };
}

function buildActivitiesSearchIndex(activities) {
    if (!Array.isArray(activities)) return new Map();
    const index = new Map();

    activities.forEach((activity) => {
        const id = String(activity?.Id ?? '').trim();
        if (!id) return;

        const coordinator = getCoordinatorData(activity);
        const ageGroups = getDisplayAgeGroups(activity?.HKN_GrupoEdad__c).join(' ');
        const rawText = [
            activity?.Name,
            activity?.HKN_Proyecto__c,
            activity?.HKN_GrupoEdad__c,
            ageGroups,
            activity?.HKN_DiaCelebracion__c,
            activity?.HKN_HoraCelebracion__c,
            activity?.HKN_Nombre_coord__c,
            coordinator?.tel,
            coordinator?.telDigits,
            activity?.HKN_Address__c?.city,
            activity?.HKN_Address__c?.state,
            activity?.HKN_Address__c?.country,
            activity?.HKN_Address__c?.street,
            stripTags(activity?.HKN_Descripcion_Activ__c)
        ].filter(Boolean).join(' ');

        index.set(id, normalizeSearchText(rawText));
    });

    return index;
}

function filterActivitiesBySearch(activities, searchTerm, searchIndex) {
    if (!Array.isArray(activities)) return [];

    const normalizedSearch = normalizeSearchText(searchTerm);
    if (!normalizedSearch) return activities.slice();

    const tokens = normalizedSearch.split(/\s+/).filter(Boolean);
    if (!tokens.length) return activities.slice();

    return activities.filter((activity) => {
        const id = String(activity?.Id ?? '').trim();
        if (!id) return false;
        const haystack = String(searchIndex?.get(id) || '');
        return tokens.every((token) => haystack.includes(token));
    });
}

function readFilterCriteriaFromDom() {
    const form = document.getElementById('filters-form');
    if (!form) return null;

    const selectedFiltersInput = document.getElementById('selected-filters');
    const mainFilterName = String(selectedFiltersInput?.name || 'HKN_GrupoEdad__c').trim();

    const mainValues = Array.from(form.querySelectorAll('.age-group-checkbox:checked'))
        .map((checkbox) => String(checkbox?.value || '').trim())
        .filter(Boolean);

    const subtypeValues = Array.from(form.querySelectorAll('.subtype-checkbox:checked'))
        .map((checkbox) => String(checkbox?.value || '').trim())
        .filter(Boolean);

    const startDate = String(form.querySelector('#StartDate')?.value || '').trim();
    const endDate = String(form.querySelector('#EndDate')?.value || '').trim();
    const stateCode = String(form.querySelector('#HKN_Address__StateCode__s')?.value || '').trim();
    const weekDay = String(form.querySelector('#HKN_DiaCelebracion__c')?.value || '').trim();

    return {
        mainFilterName,
        mainValues,
        subtypeValues,
        startDate,
        endDate,
        stateCode,
        weekDay
    };
}

function normalizeFilterToken(value) {
    return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, ' ');
}

function splitFilterValues(value) {
    return String(value || '')
        .split(/[;,]/)
        .map((part) => String(part || '').trim())
        .filter(Boolean);
}

function parseDateForFiltering(value) {
    const raw = String(value || '').trim();
    if (!raw) return null;

    const datePart = raw.includes('T') ? raw.split('T')[0] : raw;
    const parts = datePart.split('-').map(Number);
    if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) {
        return null;
    }

    const [year, month, day] = parts;
    if (!year || !month || !day) {
        return null;
    }

    const parsed = new Date(year, month - 1, day);
    if (Number.isNaN(parsed.getTime())) {
        return null;
    }

    parsed.setHours(0, 0, 0, 0);
    return parsed;
}

function activityMatchesSelectedValues(activityRawValue, selectedValues) {
    if (!Array.isArray(selectedValues) || !selectedValues.length) return true;

    const activityValues = splitFilterValues(activityRawValue).map(normalizeFilterToken);
    if (!activityValues.length) return false;

    const activityValueSet = new Set(activityValues);
    return selectedValues.some((selected) => activityValueSet.has(normalizeFilterToken(selected)));
}

function activityMatchesSelectedAgeGroups(activityRawGroups, selectedGroups) {
    if (!Array.isArray(selectedGroups) || !selectedGroups.length) return true;

    const normalizedSelected = selectedGroups.map(normalizeFilterToken).filter(Boolean);
    if (!normalizedSelected.length) return true;

    const rawGroups = splitFilterValues(activityRawGroups);
    const normalizedRawGroups = rawGroups.map(normalizeFilterToken).filter(Boolean);
    const rawGroupSet = new Set(normalizedRawGroups);

    const displayGroups = getDisplayAgeGroups(activityRawGroups).map(normalizeFilterToken);
    const displayGroupSet = new Set(displayGroups);
    const allGroupsToken = normalizeFilterToken('Todos los grupos');
    const activityIsAllGroups = displayGroupSet.has(allGroupsToken);

    return normalizedSelected.some((selectedGroup) => {
        if (selectedGroup === allGroupsToken) {
            return activityIsAllGroups;
        }

        if (rawGroupSet.has(selectedGroup) || displayGroupSet.has(selectedGroup)) {
            return true;
        }

        // Si una actividad está abierta a todos los grupos, debe aparecer
        // también al filtrar por un grupo concreto.
        return activityIsAllGroups;
    });
}

function filterActivitiesByFormCriteria(activities, criteria = {}, activityType = '') {
    if (!Array.isArray(activities) || !activities.length) return [];

    const mainFilterName = String(criteria?.mainFilterName || 'HKN_GrupoEdad__c').trim();
    const mainValues = Array.isArray(criteria?.mainValues)
        ? criteria.mainValues.map((value) => String(value || '').trim()).filter(Boolean)
        : [];
    const subtypeValues = Array.isArray(criteria?.subtypeValues)
        ? criteria.subtypeValues.map((value) => String(value || '').trim()).filter(Boolean)
        : [];
    const startDate = parseDateForFiltering(criteria?.startDate);
    const endDate = parseDateForFiltering(criteria?.endDate);
    const stateCode = normalizeFilterToken(criteria?.stateCode);
    const weekDay = normalizeFilterToken(criteria?.weekDay);

    return activities.filter((activity) => {
        const activitySubtypes = String(activity?.HKN_SubTipoActividad__c || '');

        if (mainValues.length) {
            if (mainFilterName === 'HKN_Proyecto__c') {
                if (!activityMatchesSelectedValues(activity?.HKN_Proyecto__c, mainValues)) {
                    return false;
                }
            } else if (mainFilterName === 'HKN_SubTipoActividad__c') {
                if (!activityMatchesSelectedValues(activitySubtypes, mainValues)) {
                    return false;
                }
            } else if (!activityMatchesSelectedAgeGroups(activity?.HKN_GrupoEdad__c, mainValues)) {
                return false;
            }
        }

        // Filtro secundario de tipo en retiros.
        if (subtypeValues.length && !activityMatchesSelectedValues(activitySubtypes, subtypeValues)) {
            return false;
        }

        if (stateCode) {
            const activityState = normalizeFilterToken(activity?.HKN_Address__StateCode__s);
            if (activityState !== stateCode) {
                return false;
            }
        }

        if (weekDay) {
            const activityWeekDay = normalizeFilterToken(activity?.HKN_DiaCelebracion__c);
            if (activityWeekDay !== weekDay) {
                return false;
            }
        }

        if (startDate || endDate) {
            const activityStart = parseDateForFiltering(activity?.StartDate);
            const activityEnd = parseDateForFiltering(activity?.EndDate);

            if (startDate && (!activityStart || activityStart < startDate)) {
                return false;
            }
            if (endDate && (!activityEnd || activityEnd > endDate)) {
                return false;
            }
        }

        return true;
    });
}

function normalizeSearchText(value) {
    return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, ' ');
}

function sanitizeUrl(url) {
    const value = String(url || '').trim();
    if (!value) return '';
    if (/^(https?:|mailto:|tel:)/i.test(value)) return value;
    if (value.startsWith('//')) return `https:${value}`;
    if (/^(www\.|api\.whatsapp\.com|chat\.whatsapp\.com)/i.test(value)) return `https://${value}`;
    if (value.startsWith('/')) return value;
    return '';
}

function escapeHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function escapeAttribute(value) {
    return escapeHtml(value);
}

function truncateText(value, maxLength = 200) {
    const text = String(value || '').trim();
    if (text.length <= maxLength) return text;
    return `${text.slice(0, maxLength - 1).trimEnd()}…`;
}

/**
 * Devuelve el color correspondiente al tipo de actividad para el marcador/mapa.
 */
const getColorByActivityType = (activityType) => {
    const colors = {
        "Escapada": "#98D100",
        "Hora Santa": "#99F4FA",
        "Compartiriado": "#026876",
        "Revolcadero": "#2EB0C1",
        "Retiro": "#7DC1FF",
        "Encuentro": "#00CCD9",
        "Evento": "#00CCD9",
        "Novios y Matrimonios": "#FFBF60"
    };
    return colors[activityType] || colors["Otros"];
};

const SPECIAL_MARKER_ICON_SIZE = 35;
const SPECIAL_MARKER_ICON_X = 8;
const SPECIAL_MARKER_ICON_Y = 8;

const isSpecialMarkerIconUrl = (iconUrl) => {
    return /\/assets\/icons\/apple-icons\//i.test(String(iconUrl || ''));
};

const getSvgViewBox = (svgMarkup) => {
    if (typeof svgMarkup !== 'string') return '';
    const openTagMatch = svgMarkup.match(/<svg\b[^>]*>/i);
    if (!openTagMatch) return '';
    const viewBoxMatch = openTagMatch[0].match(/\bviewBox\s*=\s*["']([^"']+)["']/i);
    return viewBoxMatch ? viewBoxMatch[1].trim() : '';
};

const getSvgInnerMarkup = (svgMarkup) => {
    if (typeof svgMarkup !== 'string') return '';
    const normalized = svgMarkup.trim();
    if (!normalized) return '';

    const openTagMatch = normalized.match(/<svg\b[^>]*>/i);
    if (!openTagMatch) return normalized;

    const openTag = openTagMatch[0];
    const start = normalized.indexOf(openTag);
    const end = normalized.toLowerCase().lastIndexOf('</svg>');

    if (start === -1 || end === -1 || end <= start) return normalized;
    return normalized.slice(start + openTag.length, end).trim();
};

const buildSpecialMarkerIcon = (svgMarkup) => {
    const innerMarkup = getSvgInnerMarkup(svgMarkup);
    if (!innerMarkup) return '';

    const viewBox = getSvgViewBox(svgMarkup) || '0 0 24 24';
    return `<svg x="${SPECIAL_MARKER_ICON_X}" y="${SPECIAL_MARKER_ICON_Y}" width="${SPECIAL_MARKER_ICON_SIZE}" height="${SPECIAL_MARKER_ICON_SIZE}" viewBox="${viewBox}" preserveAspectRatio="xMidYMid meet">${innerMarkup}</svg>`;
};

/**
 * Genera el SVG para un marcador avanzado personalizado con un icono SVG en su interior.
 */
const getCustomMarkerSVG = async (color, iconUrl) => {
    let iconSVG = await getSVGContent(iconUrl);
    if (!iconSVG) {
        iconSVG = await getSVGContent(getDefaultMapAgeIconUrl());
    }
    if (!iconSVG) {
        iconSVG = '<circle cx="15.5" cy="15.5" r="7.5" fill="#ffffff" />';
    }

    const iconLayer = isSpecialMarkerIconUrl(iconUrl)
        ? (buildSpecialMarkerIcon(iconSVG) || '<circle cx="25.5" cy="25.5" r="9" fill="#ffffff" />')
        : `<g transform="translate(10,10)">${iconSVG}</g>`;

    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="51" height="60" viewBox="0 0 51 60" fill="none">
            <path d="M51 25.7143C51 37.7475 42.8035 47.8502 31.7333 50.6548C28.5265 51.4672 26.8644 60 25.5 60C23.9798 60 22.4499 51.4613 19.2667 50.6548C8.19653 47.8502 0 37.7475 0 25.7143C0 11.5127 11.4167 0 25.5 0C39.5833 0 51 11.5127 51 25.7143Z" fill="${color}"/>
            ${iconLayer}
        </svg>
    `;
    return "data:image/svg+xml;utf-8," + encodeURIComponent(svg);
};

/**
 * Genera un SVG con las iniciales del proyecto para 'Compartiriado'.
 */
const getInitialLetters = (color, text)  => {
    const safeText = (typeof text === 'string' ? text : '').trim();

    if (!safeText) {
        return '';
    }

    const words = safeText.trim().split(/\s+/);
    let initials = '';
    let counter = 0;
    for (const word of words) {
        if (word && counter < 2) {
            initials += word[0].toUpperCase();
            counter++;
        }
    }
    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="51" height="60" viewBox="0 0 51 60" fill="none">
            <path d="M51 25.7143C51 37.7475 42.8035 47.8502 31.7333 50.6548C28.5265 51.4672 26.8644 60 25.5 60C23.9798 60 22.4499 51.4613 19.2667 50.6548C8.19653 47.8502 0 37.7475 0 25.7143C0 11.5127 11.4167 0 25.5 0C39.5833 0 51 11.5127 51 25.7143Z" fill="${color}"/>
            <text x="50%" y="50%" font-size="20" font-family="Montserrat, Arial, sans-serif" fill="#ffffff" dominant-baseline="middle" text-anchor="middle">
                ${initials}
            </text>
        </svg>
    `;
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

/**
 * Devuelve la URL del icono correspondiente al grupo de edad.
 */
const getIconByAgeGroup = (groupAge) => {
    if (!groupAge) return getDefaultMapAgeIconUrl();
    const firstGroup = String(groupAge).split(/[,;]/)[0].trim();
    if (!firstGroup) return getDefaultMapAgeIconUrl();

    const specialIcon = getSpecialAgeGroupIcon(firstGroup);
    if (specialIcon) {
        return `${window.location.origin}/wp-content/plugins/hakuna-extras/assets/icons/apple-icons/${specialIcon.file}`;
    }

    const canonicalGroup = getCanonicalAgeGroupIconBase(firstGroup);
    const normalizedGroup = normalizeAgeGroupKey(canonicalGroup);
    if (!normalizedGroup) {
        return getDefaultMapAgeIconUrl();
    }

    return `${window.location.origin}/wp-content/themes/compi/assets/img/map-icons/${normalizedGroup}.svg`;
};

const getDefaultMapAgeIconUrl = () => {
    return `${window.location.origin}/wp-content/themes/compi/assets/img/map-icons/todos los grupos.svg`;
};

const normalizeSvgForMarker = (svgMarkup) => {
    if (typeof svgMarkup !== 'string') return '';

    const sanitized = svgMarkup
        .replace(/<\?xml[\s\S]*?\?>/gi, '')
        .replace(/<!doctype[\s\S]*?>/gi, '')
        .trim();

    if (!sanitized) return '';

    const lower = sanitized.toLowerCase();
    const start = lower.indexOf('<svg');
    const end = lower.lastIndexOf('</svg>');

    if (start === -1 || end === -1 || end <= start) {
        return sanitized;
    }

    return sanitized.slice(start, end + 6);
};

/**
 * Devuelve el contenido SVG en texto desde la url indicada (usado para marcadores personalizados).
 */
const getSVGContent = async (url) => {
    if (!url) return '';
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("No se pudo cargar el SVG");
        const rawSvg = await response.text();
        return normalizeSvgForMarker(rawSvg);
    } catch (error) {

        console.error(`Error cargando el SVG: ${error.message} -> ${url}`);
        return '';
    }
};

/**
 * Da formato a un rango de fechas para mostrarlas correctamente en las fichas/listados.
 */
const formatearRangoFechas = (fechaInicio, fechaFin) => {
    if (!fechaInicio || !fechaFin) return '';
    const inicio = new Date(fechaInicio);
    const fin = new Date(fechaFin);
    if (isNaN(inicio.getTime()) || isNaN(fin.getTime())) return '';
    const meses = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];
    const diaInicio = inicio.getDate();
    const diaFin = fin.getDate();
    const mesInicio = inicio.getMonth();
    const mesFin = fin.getMonth();
    const añoInicio = inicio.getFullYear();
    const añoFin = fin.getFullYear();
    if (mesInicio === mesFin && añoInicio === añoFin) {
        return `${diaInicio} al ${diaFin} de ${meses[mesInicio]} de ${añoInicio}`;
    } else if (añoInicio === añoFin) {
        return `${diaInicio} de ${meses[mesInicio]} al ${diaFin} de ${meses[mesFin]} de ${añoInicio}`;
    } else {
        return `${diaInicio} de ${meses[mesInicio]} de ${añoInicio} al ${diaFin} de ${meses[mesFin]} de ${añoFin}`;
    }
};

const formatearEscapadaCompacta = (fechaInicio, fechaFin) => {
    if (!fechaInicio || !fechaFin) return '';
    const inicio = new Date(fechaInicio);
    const fin = new Date(fechaFin);
    if (isNaN(inicio.getTime()) || isNaN(fin.getTime())) return '';

    const mesesUpper = [
        "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
        "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];
    const mesesShort = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];

    const diaInicio = inicio.getDate();
    const diaFin = fin.getDate();
    const mesInicio = inicio.getMonth();
    const mesFin = fin.getMonth();
    const anioInicio = inicio.getFullYear();
    const anioFin = fin.getFullYear();

    let monthLabel = `${mesesUpper[mesInicio]} ${anioInicio}`;
    let dayLabel = diaInicio === diaFin ? `${diaInicio}` : `${diaInicio}-${diaFin}`;

    if (mesInicio !== mesFin || anioInicio !== anioFin) {
        if (anioInicio === anioFin) {
            monthLabel = `${mesesUpper[mesInicio]} ${anioInicio}`;
            dayLabel = `${diaInicio} ${mesesShort[mesInicio]} - ${diaFin} ${mesesShort[mesFin]}`;
        } else {
            monthLabel = `${mesesUpper[mesInicio]} ${anioInicio}`;
            dayLabel = `${diaInicio} ${mesesShort[mesInicio]} - ${diaFin} ${mesesShort[mesFin]} ${anioFin}`;
        }
    }

    return `<span class="card-map__date-month">${monthLabel}</span><span class="card-map__date-range">${dayLabel}</span>`;
};

const joinLocationParts = (...parts) => {
    return parts
        .map(part => String(part ?? '').trim())
        .filter(Boolean)
        .join(', ');
};

const SCHEDULE_VARIABLE_REGEX = /\b(variable|variables|a concretar|por confirmar|por definir|pendiente|sin definir|tbd|tbc|to be confirmed|to be defined)\b/i;

const normalizeScheduleValue = (value) => {
    return String(value ?? '')
        .replace(/\s+/g, ' ')
        .trim();
};

const hasVariableScheduleValue = (value) => {
    const normalized = normalizeScheduleValue(value)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

    if (!normalized) return false;
    return SCHEDULE_VARIABLE_REGEX.test(normalized);
};

const getRenderableSchedule = (activity) => {
    const day = normalizeScheduleValue(activity?.HKN_DiaCelebracion__c);
    const time = normalizeScheduleValue(activity?.HKN_HoraCelebracion__c);

    // If Salesforce marks schedule as variable/non-fixed, hide schedule completely.
    if (hasVariableScheduleValue(day) || hasVariableScheduleValue(time)) {
        return { day: '', time: '' };
    }

    return { day, time };
};

const normalizeGroupLabel = (label = '') => {
    return String(label)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toUpperCase();
};

const getDisplayAgeGroups = (rawGroups = '') => {
    const groups = String(rawGroups || '')
        .split(/[,;]/)
        .map(g => String(g || '').trim())
        .filter(Boolean);

    if (!groups.length) return [];

    const uniqueGroups = Array.from(new Set(groups));
    const normalized = uniqueGroups.map(group => normalizeGroupLabel(getCanonicalAgeGroupIconBase(group)));
    const allCoreGroups = ['UNIVERSITARIOS', 'PROFESIONALES', 'FRONTERA', 'SUMMIT', 'SENIOR'];
    const hasAllCoreGroups = allCoreGroups.every(group => normalized.includes(group));

    if (hasAllCoreGroups) {
        return ['Todos los grupos'];
    }

    return uniqueGroups;
};

const getCoordinatorData = (activity) => {
    const name = String(activity?.HKN_Nombre_coord__c ?? '').trim();
    const prefix = String(activity?.HKN_Tlf_Prefix_coordinador__c ?? '').replace(/\s+/g, '');
    const phone = String(activity?.HKN_Tlf_coordinador__c ?? '').replace(/\s+/g, '');
    const tel = `${prefix}${phone}`.trim();
    const telDigits = tel.replace(/\D+/g, '');
    return { name, tel, telDigits };
};

const buildCoordinatorWhatsAppUrl = (activity, activityName = '') => {
    const coordinator = getCoordinatorData(activity);
    if (!coordinator.telDigits) return '';
    const text = encodeURIComponent(`Hola, te contacto por ${activityName || 'esta actividad'} desde hakuna.org.`);
    return `https://api.whatsapp.com/send?phone=${coordinator.telDigits}&text=${text}`;
};

function set_icon(color){
    var icon = `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3068_28849)">
        <path d="M15.9898 10.0742C15.2188 10.8646 15.2306 12.1136 16.0284 12.8896C16.0491 12.9098 16.0699 12.9242 16.0907 12.9444" stroke="${color}" stroke-width="0.545455" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16.3118 12.9039L15.7217 12.5029" stroke="${color}" stroke-width="0.545455" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2.07676 7.62207L1.5222 7.73169C0.715572 7.87015 0.175839 8.61726 0.318186 9.40188C0.380463 9.73938 0.561362 10.025 0.807504 10.2326L5.54647 14.274" stroke="${color}" stroke-width="0.545455" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M0.297363 3.67334V6.55795" stroke="${color}" stroke-width="0.545455" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M0.297363 3.96165L8.00782 7.13473H8.60094L16.3114 3.96165V3.38473L8.60094 0.788574H8.00782L0.297363 3.38473V3.96165Z" stroke="${color}" stroke-width="0.545455" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.26294 5.18213V7.87059C3.26294 8.1504 3.40232 8.41001 3.63363 8.57444C6.30857 10.5014 10.3002 10.5014 12.9752 8.57444C13.2065 8.40713 13.3458 8.14751 13.3458 7.87059V5.18213" stroke="${color}" stroke-width="0.545455" stroke-linejoin="round"/>
        <path d="M14.35 8.68359L16.3102 10.0192L6.26586 11.773C5.45922 11.9115 4.91949 12.6586 5.06184 13.4432C5.20419 14.2278 5.97227 14.7528 6.7789 14.6144L16.3102 12.9997" stroke="${color}" stroke-width="0.545455" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_3068_28849">
        <rect width="16.6071" height="15" fill="white" transform="translate(0 0.5)"/>
        </clipPath>
        </defs>
        </svg>`;
    return '';
}
/**
 * Calcula la distancia (en km) entre dos coordenadas (Haversine).
 */
function distanceBetween(lat1, lng1, lat2, lng2) {
    const R = 6371; // km
    const dLat = (lat2-lat1) * Math.PI/180;
    const dLng = (lng2-lng1) * Math.PI/180;
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(lat1*Math.PI/180) * Math.cos(lat2*Math.PI/180) *
        Math.sin(dLng/2) * Math.sin(dLng/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
}

/**
 * Ordena un array de actividades por distancia respecto a un punto (lat, lng).
 */
function ordenarPorDistancia(center, actividades) {
    return actividades
        .map(act => {
            const lat = act?.HKN_Address__c?.latitude;
            const lng = act?.HKN_Address__c?.longitude;
            if (lat == null || lng == null) return { ...act, _dist: Infinity };
            const dist = distanceBetween(center.lat, center.lng, lat, lng);
            return { ...act, _dist: dist };
        })
        .sort((a, b) => a._dist - b._dist);
}

/**
 * Reordena en el DOM los elementos del listado según el nuevo orden de actividades.
 * IMPORTANTE: el contenedor debe tener id="contenedor-listado"
 * @param {Array} actividadesOrdenadas - Array de actividades ya ordenadas
 */
function reordenarListado(actividadesOrdenadas) {
    const container = document.getElementById('contenedor-listado'); // Cambia por tu id real si es otro
    if (!container) return;
    actividadesOrdenadas.forEach(act => {
        const div = container.querySelector(`[data-activityId-list="${act.Id}"]`);
        if (div) container.appendChild(div);
    });
}

function stripTags(html) {
    return new DOMParser().parseFromString(String(html ?? ''), 'text/html')
        .body.textContent || '';
}

/*
 =========================================================================
 NOTAS IMPORTANTES PARA OTROS DESARROLLADORES:

 - Este script depende de que la variable global 'map_data' esté disponible y correctamente configurada desde PHP.
 - Los divs de listado deben tener el atributo data-activityId-list con el ID exacto de cada actividad.
 - Asegúrate de tener los siguientes IDs en el HTML:
      - #contenedor-listado: contenedor padre del listado de actividades
 - #no-activities-message: div para mensaje de vacío/no resultados del listado
      - #no-data-map: div para mensaje "no hay datos cargados para mostrar en el mapa"
 - El MapId de Google Maps ('TU_MAP_ID') debe ser sustituido por el MapId correcto si se usan estilos vectoriales o avanzados.
 - El código usa la API AdvancedMarkerElement y MarkerClusterer, recomendadas por Google para la nueva generación de mapas.
 - En páginas Near Me el orden del listado por distancia usa la posición del usuario si se permite geolocalización; si no, usa centro por defecto.
 - Recuerda mantener los assets de iconos en la ruta esperada (`/wp-content/themes/compi/assets/img/map-icons/`)
 - Los SVG personalizados para marcadores e info windows están embebidos vía data URI para compatibilidad cross-browser.
 =========================================================================
*/
